/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select({
  web: () => require("./SwimmingLanePreviousOverlay.web").default,
  default: () => () => null,
})();

export type { SwimmingLanePreviousOverlayProps } from "./SwimmingLanePreviousOverlay.web";
